//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"OpenFile",1,0],[0,"OutputFile",1,0],[0,"OutputFormat",1,0],[0,"PageOrientation",1,0],[0,"PageSize",1,0],[0,"ScaleFactor",1,0]],[[["objects","firstSelObj","current_view"],"Publish",{},3,0]],[]];
SPLM.CAM.WorkInstructionOutputBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.WorkInstructionOutputBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.WorkInstructionOutputBuilder.OutputFormatType = Object.freeze({
    "Html" : "Html", "Pdf" : "Pdf", "Csv" : "Csv", "Xml" : "Xml"});

SPLM.CAM.WorkInstructionOutputBuilder.PageOrientationType = Object.freeze({
    "Landscape" : "Landscape", "Portrait" : "Portrait"});

SPLM.CAM.WorkInstructionOutputBuilder.PageSizeType = Object.freeze({
    "A0" : "A0", "A1" : "A1", "A2" : "A2", "A3" : "A3", "A4" : "A4", "B1" : "B1", "B2" : "B2", "B3" : "B3", "B4" : "B4", "B5" : "B5", "Executive" : "Executive", "Folio" : "Folio", "Legal" : "Legal", "Letter" : "Letter", "Tabloid" : "Tabloid"});

export default SPLM;